"use client"

import { createContext, useContext, useState } from "react"

/**
 * Wybrany kolor koszulki żyje wyżej niż komponent, który go ustawia.
 *
 * Na stronie produktu selektor kolorów siedzi w prawej kolumnie
 * (ProductActions), a makieta z nadrukiem w środkowej (ImageGallery) — to dwa
 * osobne poddrzewa. Zamiast przepychać stan przez serwerowy szablon trzymamy
 * go w kontekście, którym szablon owija obie kolumny.
 */
type ShirtColorContextValue = {
  color?: string
  setColor: (value: string) => void
}

const ShirtColorContext = createContext<ShirtColorContextValue>({
  setColor: () => {},
})

export const ShirtColorProvider = ({
  defaultColor,
  children,
}: {
  defaultColor?: string
  children: React.ReactNode
}) => {
  const [color, setColor] = useState<string | undefined>(defaultColor)

  return (
    <ShirtColorContext.Provider value={{ color, setColor }}>
      {children}
    </ShirtColorContext.Provider>
  )
}

export const useShirtColor = () => useContext(ShirtColorContext)
